import { useState } from 'react';

import { useGenericModal } from '..';
import {
  LiveAgentPlatformModal,
  LiveAgentPlatformModalProps,
} from './live-agent-platform-modal';

type Env = 'live' | 'sandbox';

export const useLiveAgentPlatformModal = (
  props?: Partial<LiveAgentPlatformModalProps>
) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const [type, setType] = useState<LiveAgentPlatformModalProps['type']>('add');
  const [env, setEnv] = useState<Env>('live');
  const [connectionId, setConnectionId] = useState<string | undefined>();

  const modalComponent = (
    <LiveAgentPlatformModal
      testId={props?.testId}
      modalRef={modalRef}
      onClose={closeModal}
      type={type}
      env={env}
      connectionId={connectionId}
    />
  );

  const openPlatformModal = (
    nextType: NonNullable<LiveAgentPlatformModalProps['type']>,
    options?: { env?: Env; connectionId?: string }
  ) => {
    setType(nextType);
    if (options?.env) setEnv(options.env);
    setConnectionId(options?.connectionId);
    openModal();
  };

  return {
    modalRef,
    openModal: openPlatformModal,
    closeModal,
    liveAgentPlatformModal: modalComponent,
  };
};
